// UserModalForm.js
import React from "react";
import { useFormik } from "formik";
import { Modal, Button, Form } from "react-bootstrap";



const AddMasterForm = ({ formName, showAddForm, setShowAddForm, addMasterData }) => {

  const validate = (values) => {
    const errors = {};
    if (!values.name) {
      errors.name = `Please Enter ${formName} Name.`;
    } else if (!values.name.trim()) {
      errors.name = `The ${formName} Name Cannot Be Blank.`;
    }
    return errors;
  };

  const handleHide = () => {
    setShowAddForm(false)
    formik.resetForm();
  };
  const formik = useFormik({
    initialValues: {
      name: "",
    },
    validate,
    onSubmit: (values) => {
      addMasterData(values)
      handleHide();
      values.name = ""
    },
  });

  return (
    <Modal show={showAddForm} onHide={() => handleHide()} centered>
      <Modal.Header className="dialog-header" closeButton>
        <Modal.Title>Add {formName}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={formik.handleSubmit}>
          <Form.Group controlId="formName">
            <Form.Label>{formName} Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={formik.values.name}
              onChange={formik.handleChange}
              isInvalid={formik.touched.name && !!formik.errors.name}
            />
            <Form.Control.Feedback type="invalid">
              {formik.touched.name && formik.errors.name}
            </Form.Control.Feedback>
          </Form.Group>
          <br/>
          <Modal.Footer>
          <Button variant="primary" type="submit">
            Submit
          </Button>
          </Modal.Footer>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default AddMasterForm;
